export default __webpack_public_path__ + "static/media/PuntoNaranja.42c28f5c.png";